/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit App/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Confirmation from './Confirmation/index'
import DivisionIdError from './DivisionIdError/index'
import Form from './Form/index'
import GoogleTagManager from 'DesignSystem/GoogleTagManager/react'
import Loading from './Loading/index'
import PatientAlreadyExists from './PatientAlreadyExists/index'
import React from 'react'
import RuntimeError from './RuntimeError/index'
import WelcomeScreen from './WelcomeScreen/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function App({
  children,
  viewPath = "/App",
  gtmData,
  container,
  backgroundColor = "white",
  isShrunk
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Loading'
  return (<React.Fragment
>
<GoogleTagManager
  viewPath={`${viewPath}/GoogleTagManager`}
 data={gtmData}
/>
<div
  data-testid="App.Vertical"
  data-view-path={viewPath}
 ref={container}
 style={{'--bc-5-hJL': backgroundColor,'--fg-1-hJL': isShrunk ? 0 : 1,'--fs-2-hJL': isShrunk ? 0 : 1,'--pt-3-hJL': isShrunk ? "20px" : "0px",'--pb-4-hJL': isShrunk ? "20px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'WelcomeScreen'}>
<WelcomeScreen
  viewPath={`${viewPath}/WelcomeScreen`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Form'}>
<Form
  viewPath={`${viewPath}/Form`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Confirmation'}>
<Confirmation
  viewPath={`${viewPath}/Confirmation`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientAlreadyExists'}>
<PatientAlreadyExists
  viewPath={`${viewPath}/PatientAlreadyExists`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RuntimeError'}>
<RuntimeError
  viewPath={`${viewPath}/RuntimeError`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DivisionIdError'}>
<DivisionIdError
  viewPath={`${viewPath}/DivisionIdError`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}